import ActiveMembershipTable from './ActiveMembershipTable'

export default ActiveMembershipTable
